// aifab - Login page
import { useState } from 'react';
import { apiFetch } from '../hooks/apiFetch';
import { Spinner } from '../components/common';

export default function LoginPage({ onLogin, sessionMessage }) {
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [err,      setErr]      = useState(null);
  const [loading,  setLoading]  = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr(null);
    try {
      const d = await apiFetch('/auth/login', {
        method: 'POST',
        body:   JSON.stringify({ email, password }),
      });
      const profile = {
        user_id:   d.user_id,
        email:     d.email,
        full_name: d.full_name,
        role:      d.role,
        org_id:    d.org_id,
        org_name:  d.org_name,
        must_change_password: d.must_change_password === true,
      };
      localStorage.setItem('aifab_user', JSON.stringify(profile));
      onLogin(profile);
    } catch (e) { setErr(e.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="login-page">
      <div className="login-card">

        {/* Header */}
        <div className="login-hd">
          <div className="login-wordmark">
            <span className="login-wordmark-aiiop">aiiop</span>
            <span className="login-wordmark-fabric"> Fabric</span>
          </div>
          <div className="login-subtitle">AI / ML Execution Platform · aiiop.ai</div>
        </div>

        {/* Body */}
        <div className="login-body">
          {sessionMessage && (
            <div className="login-notice login-notice--warn">
              <span className="login-notice-icon">⚠</span>
              {sessionMessage}
            </div>
          )}
          {err && (
            <div className="login-notice login-notice--err">
              <span className="login-notice-icon">✕</span>
              {err}
            </div>
          )}

          <form onSubmit={submit} className="login-form">
            <div className="form-grp">
              <label className="form-lbl">Email</label>
              <input
                className="form-inp"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                autoFocus
                placeholder="you@company.com"
              />
            </div>
            <div className="form-grp">
              <label className="form-lbl">Password</label>
              <input
                className="form-inp"
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
              />
            </div>
            <button
              className="btn btn-primary login-btn"
              disabled={loading}
              type="submit"
            >
              {loading ? <Spinner size={14} /> : 'Sign In'}
            </button>
          </form>
        </div>

        {/* Footer */}
        <div className="login-ft">
          aiiop.ai · Secure access · Session expires on inactivity
        </div>
      </div>
    </div>
  );
}
